import { render } from "./holidayBookingBox.vue?vue&type=template&id=a8d31244&ts=true"
import script from "./holidayBookingBox.vue?vue&type=script&lang=ts"
export * from "./holidayBookingBox.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__